import * as React from "react";
import { LoadingButtonProps, LoadingButton } from "@mui/lab";
import { getButtonStyle } from "./cclButtonStylings";
import { SxProps, Theme } from "@mui/material/styles";

type CclLoadingButtonProps = LoadingButtonProps & {
    mode: "primary" | "secondary" | "tertiary";
};

export const CclLoadingButton: React.FC<CclLoadingButtonProps> = (props) => {
    const { mode, sx, children, ...passthroughprops } = props;

    const styling: SxProps<Theme> = [
        getButtonStyle(mode, passthroughprops.size === "small"),
        {
            "&.MuiLoadingButton-loading": {
                color: "transparent",
            },
            "&.MuiLoadingButton-loading .MuiLoadingButton-loadingIndicator": {
                opacity: 1,
                "& .MuiCircularProgress-circle": {
                    strokeWidth: 6,
                    color: "primary.main",
                },
            },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ];

    return (
        <LoadingButton sx={styling} {...passthroughprops}>
            {children}
        </LoadingButton>
    );
};

export default CclLoadingButton;
